import { Modal } from '@veneer/core';
import styled from 'styled-components';

import {
  color,
  layout,
  minDesktopLarge,
  minDesktopRegular,
  minDesktopSmall,
  minDesktopXS,
  minMobile,
  minTablet,
} from '../../GlobalStylesVisid';

const { white, black } = color;
const { size6, size8 } = layout;

export const MainContent = styled.div`
  padding: ${size6}px ${size8}px;

  ${minTablet} {
    padding: 40px;
  }
`;

export const CustomModal = styled(Modal)`
  && {
    padding: 0;
    width: 343px;

    ${minMobile} {
      width: 448px;
    }
    ${minTablet} {
      width: 704px;
    }
    ${minDesktopXS} {
      width: 715px;
    }
    ${minDesktopSmall} {
      width: 781px;
    }
    ${minDesktopRegular} {
      width: 952px;
    }
    ${minDesktopLarge} {
      width: 1064px;
    }
  }

  [class~='vn-modal__close'] {
    color: ${black};
    background-color: ${white};
    border-radius: 50%;

    &:hover {
      color: ${white};
    }
  }
`;
